(function () {
  if (window.__ugOktoberfestDealsExpand) return;
  window.__ugOktoberfestDealsExpand = true;

  const controllers = new WeakMap();
  const sectionSelector = '[data-ok-deals]';

  function initialize(section) {
    if (controllers.has(section)) return controllers.get(section);

    const grid = section.querySelector('[data-ok-deals-grid]');
    const button = section.querySelector('[data-ok-deals-toggle]');
    const footer = section.querySelector('[data-ok-deals-footer]');
    if (!grid || !button || !footer) return null;

    const items = Array.from(grid.querySelectorAll('[data-ok-deals-item]'));
    const visibleCount = Number(section.dataset.okDealsVisibleCount) || 4;
    if (items.length <= visibleCount) return null;

    const label = button.querySelector('.ug-pc__grid-cta__label');
    let expanded = false;

    function setExpanded(value) {
      expanded = value;
      items.forEach(function (item, index) {
        item.hidden = !expanded && index >= visibleCount;
      });
      button.setAttribute('aria-expanded', String(expanded));
      if (label) {
        label.textContent = expanded
          ? button.dataset.okDealsLabelCollapse
          : button.dataset.okDealsLabelExpand;
      }
    }

    button.addEventListener('click', function () {
      setExpanded(!expanded);
      if (!expanded) {
        const bounds = button.getBoundingClientRect();
        if (bounds.top < 0 || bounds.bottom > window.innerHeight) {
          button.scrollIntoView({ block: 'nearest', behavior: 'auto' });
        }
      }
    });

    const controller = {
      revealBlock: function (blockId) {
        const item = items.find(function (candidate) {
          return candidate.dataset.okDealsItem === blockId;
        });
        if (!item || !item.hidden) return;
        setExpanded(true);
        item.scrollIntoView({ block: 'center', behavior: 'auto' });
      }
    };
    controllers.set(section, controller);
    setExpanded(false);
    footer.hidden = false;
    return controller;
  }

  function initializeWithin(scope) {
    if (scope.matches && scope.matches(sectionSelector)) initialize(scope);
    scope.querySelectorAll(sectionSelector).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    }, { once: true });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const blockId = event.detail && event.detail.blockId;
    if (!blockId) return;
    const section = event.target.closest(sectionSelector);
    if (!section) return;
    const controller = initialize(section);
    if (controller) controller.revealBlock(blockId);
  });
})();
